var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.549,
    height: 140.227,
    viewBox: "0 0 138.549 140.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Oval_2",
    x: 0,
    y: 0,
    width: 138.549,
    height: 140.227,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6852",
    "data-name": "Rectangle 6852",
    width: 42.972,
    height: 64.026,
    fill: "#09bc8a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15529",
    "data-name": "Group 15529",
    transform: "translate(-479.661 -196.078)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 479.66, 196.08)",
    filter: "url(#Oval_2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2-2",
    "data-name": "Oval 2",
    cx: 56.775,
    cy: 57.614,
    rx: 56.775,
    ry: 57.614,
    transform: "translate(12.5 9.5)",
    fill: "#fff",
    stroke: "#09bc8a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15469",
    "data-name": "Group 15469",
    transform: "translate(514.96 231.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15468",
    "data-name": "Group 15468",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13715",
    "data-name": "Path 13715",
    d: "M31.013,64.027a11.538,11.538,0,0,0,4.528-.89c6.472-2.778,7.393-10.983,7.429-11.331a.368.368,0,0,0-.328-.4.372.372,0,0,0-.4.328c-.008.081-.909,8.122-6.988,10.731a11.186,11.186,0,0,1-6.335.634,10.19,10.19,0,0,1-5.084-2.959A42.766,42.766,0,0,1,17.48,48.829a15.676,15.676,0,0,0-.915-1.875,18.866,18.866,0,0,0-3.025-3.82c-1.7-1.794-3.065-3.2-4.006-4.17a27.286,27.286,0,0,1-7.639-11.7A26.113,26.113,0,0,1,.833,22.523,19.7,19.7,0,0,1,3.4,10.645a19.93,19.93,0,0,1,11.771-8.9c15.452-5.092,24.4,10.9,24.488,11.058a.368.368,0,1,0,.646-.353c-.091-.168-9.32-16.689-25.346-11.41a20.664,20.664,0,0,0-12.193,9.23A20.448,20.448,0,0,0,.1,22.608a26.923,26.923,0,0,0,1.093,4.881,28.374,28.374,0,0,0,7.826,12c.924.951,2.285,2.358,3.986,4.149a18.059,18.059,0,0,1,2.92,3.679,15.188,15.188,0,0,1,.868,1.778,43.456,43.456,0,0,0,6.478,11.516,10.944,10.944,0,0,0,5.478,3.2,10.909,10.909,0,0,0,2.262.215",
    transform: "translate(-0.001 0)",
    fill: "#09bc8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13716",
    "data-name": "Path 13716",
    d: "M33.7,88.231A5.875,5.875,0,0,0,35.351,88,4.918,4.918,0,0,0,38.02,86.17a5.78,5.78,0,0,0-.384-6.429.368.368,0,0,0-.611.411,5.048,5.048,0,0,1,.391,5.6A4.251,4.251,0,0,1,35.132,87.3a4.871,4.871,0,0,1-4.268-.781,4.561,4.561,0,0,1-1.581-3.011,6.3,6.3,0,0,0-1.645-3.646,6.376,6.376,0,0,0-4.087-1.958,7.534,7.534,0,0,1-1.426-.323,9.255,9.255,0,0,1-2.166-1.132,15.9,15.9,0,0,1-3.907-4.863,9.961,9.961,0,0,1-1-5.936A10.409,10.409,0,0,1,19.9,58.558a11.247,11.247,0,0,1,6.146-1.688,14.188,14.188,0,0,1,5.782,1.008.368.368,0,1,0,.272-.684,14.838,14.838,0,0,0-6.05-1.06A12.106,12.106,0,0,0,19.5,57.942a11.133,11.133,0,0,0-5.168,7.6A10.693,10.693,0,0,0,15.4,71.925a16.3,16.3,0,0,0,4.134,5.126,9.864,9.864,0,0,0,2.363,1.231,8.288,8.288,0,0,0,1.582.356A5.643,5.643,0,0,1,27.1,80.366a5.563,5.563,0,0,1,1.451,3.218,5.3,5.3,0,0,0,1.844,3.5A5.111,5.111,0,0,0,33.7,88.231",
    transform: "translate(-0.316 -38.507)",
    fill: "#09bc8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13717",
    "data-name": "Path 13717",
    d: "M51.845,54.338a2.782,2.782,0,0,0,.326-.016.367.367,0,0,0,.32-.41.372.372,0,0,0-.41-.32A2.831,2.831,0,0,1,49.02,49.9a2.939,2.939,0,0,1,.824-1.318,3.825,3.825,0,0,1,4.013-.378.368.368,0,0,0,.454-.144l1.456-2.331a13.351,13.351,0,0,0,.657-2.1,13.654,13.654,0,0,0,.306-3.99,13.228,13.228,0,0,0-.506-2.744A11.026,11.026,0,0,0,39.5,31.849a11.686,11.686,0,0,0-4.779,8.891.368.368,0,0,0,.736.025,11.123,11.123,0,0,1,4.466-8.314,10.291,10.291,0,0,1,15.61,4.689A12.446,12.446,0,0,1,56,39.7a12.912,12.912,0,0,1-.289,3.772,13.335,13.335,0,0,1-.594,1.928l-1.265,2.012a4.412,4.412,0,0,0-4.5.624,3.67,3.67,0,0,0-1.033,1.641,3.554,3.554,0,0,0,3.526,4.657",
    transform: "translate(-24.692 -20.447)",
    fill: "#09bc8a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15497",
    "data-name": "Group 15497",
    transform: "translate(587.325 246.325) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13789",
    "data-name": "Path 13789",
    d: "M7.809,0A10.168,10.168,0,0,0,.569,3,1.943,1.943,0,0,0,3.317,5.747a6.352,6.352,0,0,1,8.985,0A1.943,1.943,0,1,0,15.049,3a10.169,10.169,0,0,0-7.24-3",
    transform: "translate(9.057 12.809)",
    fill: "#09bc8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13790",
    "data-name": "Path 13790",
    d: "M12.333,0A16.527,16.527,0,0,0,.569,4.873,1.943,1.943,0,0,0,3.316,7.621a12.751,12.751,0,0,1,18.033,0A1.943,1.943,0,0,0,24.1,4.873,16.524,16.524,0,0,0,12.333,0",
    transform: "translate(4.533 6.412)",
    fill: "#09bc8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13791",
    "data-name": "Path 13791",
    d: "M33.164,6.752a23.046,23.046,0,0,0-32.6,0A1.943,1.943,0,1,0,3.316,9.5a19.16,19.16,0,0,1,27.1,0,1.943,1.943,0,0,0,2.749-2.747",
    transform: "translate(0 0)",
    fill: "#09bc8a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarInCircle);
export default __webpack_public_path__ + "static/media/ear-in-circle.60537d009832d45c6e6e427aed0a897d.svg";
export { ForwardRef as ReactComponent };